module.exports = __webpack_public_path__ + "static/img/delete.39508fdc.svg";